import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { CommonCd } from '../common-cd/CommonCd';

/**
 * # Terms
 *
 * Terms을 설명하세요.
 */
export const Terms = types
  .model('Terms')
  // --------------------------------------------------------------------------
  .props({
    termsSid: types.number,
    termsTypeCd: CommonCd,
    termsOrder: types.number,
    termsTitle: types.string,
    termsConts: types.string,
    useYn: types.string,
    essnYn: types.string,
    regDt: types.string,
    langCd: types.string,
    checked: types.boolean, // 약관 체크박스 이용 변수
    userSid: types.number,
    agreeYn: types.string,
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model terms --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as ITerms;
      (Object.keys(newProps) as TTermsKeys[]).forEach((key) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TTerms = Instance<typeof Terms>;
type TTermsSnapshot = SnapshotOut<typeof Terms>;

export interface ITerms extends TTerms {}
export type TTermsKeys = keyof TTermsSnapshot & string;
export interface ITermsSnapshot extends TTermsSnapshot {}
export const createTerms = () => types.optional(Terms, {} as TTerms);
